import React, { useRef, useState } from 'react';

import { useRecoilValue } from 'recoil';

import Avatar from 'components/shared/Avatar/Avatar';
import Input from 'components/shared/Input/Input';
import state from 'components/state';

const CommentInput = ({ focusOnMount, onPost, loading = false, placeholder = 'Reply' }) => {
  const inputRef = useRef(null);

  const [value, setValue] = useState('');
  const user = useRecoilValue(state.userState);

  const handlePost = () => {
    if (value.trim() === '' || loading) return;
    onPost(value);
    setValue('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handlePost();
    }
  };

  return (
    <div className="relative">
      <Avatar
        firstName={user?.f_name}
        lastName={user?.l_name}
        id={user?.id || user?.user_id}
        image={user?.profile_photo}
        className="absolute left-3 top-1/2 z-10 !h-5 !min-h-5 !w-5 !min-w-5 -translate-y-1/2"
      />
      <Input
        forwardedRef={inputRef}
        focusOnMount={focusOnMount}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={loading}
        rightIcon="send-2-mono"
        rightIconColor="primary"
        rightIconClick={handlePost}
        inputClassName="pl-7"
      />
    </div>
  );
};

export default CommentInput;
